  /**
 * External dependencies
 */
import { get, omit, forOwn, omitBy, values } from 'lodash';

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.EDIT_CONNECTION_SALES_TYPES]: (state, action) => {
            const id = action.payload.id || '';
            const connectionSalesTypes = action.payload.connectionSalesTypes;
            const newEditLogs = appendToEditsLog(get(state, id), connectionSalesTypes);

            return {
                ...state,
                [id]: newEditLogs,
            };
        },
        [actions.EDIT_CONNECTION_SALES_TYPES]: (state, action) => {
            const id = action.payload.id || '';
            return omit(state, id);
        },
    },
);